import InvoiceCandidateList from './invoice-candidate-list';

export default InvoiceCandidateList;
